// tslint:disable: member-ordering

import { prop } from 'datx';
import { inject } from 'dependable-react';
import { computed } from 'mobx';

import { Gender } from '../../enums/Gender';
import { APP_DATA_TOKEN, I18N_TOKEN } from '../../services/InjectTokens';
import { BaseModel } from './BaseModel';
import { Feature } from './Feature';
import { Field } from './Field';

export class Avatar extends BaseModel {
  public static type = 'avatar';

  private i18n = inject(I18N_TOKEN);
  private appData = inject(APP_DATA_TOKEN);

  @prop
  public id!: number;

  @prop
  public position!: number;

  @prop.toMany(Field)
  public fields!: Array<Field>;

  @prop.toMany(Feature)
  public features!: Array<Feature>;

  @prop
  public uid!: string;

  @prop
  public genderId!: number;

  @prop
  public previewImages!: any;

  @prop
  public mainCharacter!: boolean;

  @prop
  public defaultPreview!: Record<string, string>;

  @computed
  public get title() {
    return this.i18n.t(this.uid);
  }

  @computed
  public get gender() {
    return this.genderId as Gender;
  }

  @computed
  public get isCompleted() {
    return this.fields
      .filter((field) => field.inLanguages.includes(this.appData.currentLanguage))
      .every((field) => !this.computeError(field));
  }

  @computed
  public get name() {
    if (!this.params) {
      return '';
    }

    const nameFieldKey = Object.keys(this.params).find((key) => key.includes('_name'));

    return nameFieldKey ? this.params[nameFieldKey] : '';
  }

  @prop
  public params!: Record<string, string>;

  @prop
  private firstOnPage!: string;

  @prop
  public defaultValues!: Record<string, Record<string, string>>;

  @prop
  public summaries!: Record<string, Record<string, string>>;

  @computed
  public get firstAppearedOn() {
    return parseInt(this.firstOnPage, 10);
  }

  private computeError(field: Field) {
    if (!field.mandatory) {
      return false;
    }

    if (!this.params || !this.params[field.uid]) {
      return true;
    }

    return false;
  }
}
